export const ROUTE_MAP = [
  // Auth Routes
  { url: "/", name: "Login" },
  { url: "/dashboard/", name: "Stock Dashboard" },
  { url: "/outbound/dashboard", name: "Outbound Dashboard" },
  { url: "/inbound/dashboard", name: "Inbound Dashboard" },
  { url: "/setting/", name: "WMS Settings" },
  { url: "/setting/create-setting", name: "Create WMS Settings" },
  { url: "/setting/edit-setting", name: "Edit WMS Settings" },
  { url: "/setting/view-setting", name: "View WMS Settings" },
  // Inbound Routes
  {
    url: "/inbound/gate-entry/gate-entry-list",
    name: "Gate Entry List",
    removeOn: [
      "/inbound/gate-entry/create-gate-entry",
      "gate-entry/view-gate-entry",
    ],
  },
  { url: "/inbound/gate-entry/create-gate-entry", name: "Create Gate Entry" },
  { url: "/inbound/gate-entry/view-gate-entry", name: "View Gate Entry" },
  { url: "/inbound/gate-entry/edit-gate-entry/", name: "Edit Gate Entry" },

  // asn
  {
    url: "/inbound/asn/inboundasn",
    name: "Asn List",
    removeOn: [
      "/inbound/asn/createasn",
      "/inbound/asn/view/",
      "/inbound/asn/edit/",
    ],
  },
  { url: "/inbound/asn/createasn", name: "Asn Create" },
  { url: "/inbound/asn/view/", name: "Asn View" },
  { url: "/inbound/asn/edit/", name: "Asn Edit" },

  {
    url: "/inbound/purchaseorder/purchase-orders",
    name: "Purchase Orders List",
    removeOn: [
      "/inbound/purchaseorder/create-purchase-order",
      "/inbound/purchaseorder/edit-purchase-order/",
      "/inbound/purchaseorder/view-purchase-order/",
    ],
  },

  {
    url: "/inbound/purchaseorder/create-purchase-order",
    name: "Create Purchase Order",
  },
  {
    url: "/inbound/purchaseorder/duplicate-purchase-order",
    name: "Duplicate Purchase Order",
  },
  {
    url: "/inbound/purchaseorder/edit-purchase-order/",
    name: "Edit Purchase Order",
  },
  {
    url: "/inbound/purchaseorder/view-purchase-order/",
    name: "View Purchase Order",
  },
  { url: "/inbound/grn/create-purchase-receipt", name: "Create GRN" },
  { url: "/inbound/grn/edit-purchase-receipt/", name: "Edit GRN" },
  { url: "/inbound/grn/view-purchase-receipt", name: "View GRN" },
  {
    url: "/inbound/grn/create-grn-receipt",
    name: "GRN List",
    removeOn: [
      "/inbound/grn/view-purchase-receipt",
      "/inbound/grn/edit-purchase-receipt/",
    ],
  },
  { url: "/inbound/putaway/create-putaway", name: "Create Putaway" },
  { url: "/inbound/putaway/view-putaway", name: "View Putaway" },

  { url: "/inbound/putaway/edit-putaway", name: "Edit Putaway" },
  {
    url: "/inbound/putaway/create-in-putaway",
    name: "Putaway List",
    removeOn: [
      "/inbound/putaway/view-putaway",
      "/inbound/putaway/edit-putaway",
    ],
  },

  { url: "/inbound/asn/inboundasn", name: "Inbound ASN" },
  { url: "/Inbound/Inbound-Cycle-Details", name: "Inbound Cycle Details" },
  { url: "/Inbound/Posted-GRN-Report", name: "Posted GRN Report" },
  { url: "/Inbound/Inbound-Cycle-Reports", name: "Inbound Cycle Reports" },
  {
    url: "/Inbound/Purchase-Receipt-Reports",
    name: "Purchase Receipt Reports",
  },
  { url: "/Inbound/Put-away-Reports", name: "Put Away Reports" },
  { url: "/Inbound/Purchase-Order-Cycle", name: "Purchase Order Cycle" },
  { url: "/Inbound/Pending-Put-Away", name: "Pending Put Away" },
  // Outbound Routes
  {
    url: "/outbound/outbound-sales-order",
    name: "Sales Order",
    removeOn: [
      "/outbound/outbound-create-sales-order",
      "/outbound/outbound-sales-order-view/",
      "/outbound/outbound-sales-order-edit/",
    ],
  },
  { url: "/outbound/outbound-create-sales-order", name: "Create Sales Order" },
  { url: "/outbound/outbound-sales-order-view/", name: "View Sales Order" },
  { url: "/outbound/outbound-sales-order-edit/", name: "Edit Sales Order" },
  {
    url: "/outbound/outbound-sales-order-duplicate/",
    name: "Duplicate Sales Order",
  },

  {
    url: "/outbound/pick/outboundpick",
    name: "Pick List",
    removeOn: [
      "/outbound/pick/pick-view/",
      "/outbound/pick/pick-edit/",
      "/outbound/pick/createpick",
    ],
  },
  { url: "/outbound/pick/pick-view/", name: "View Pick List" },
  { url: "/outbound/pick/pick-edit/", name: "Edit Pick List" },
  { url: "/outbound/pick/createpick", name: "Create Pick" },

  {
    url: "/outbound/outbound-delivery-note",
    name: "Delivery Note  List",
    removeOn: [
      "/outbound/delivery-note-view",
      "/outbound/outbound-create-delivery-note",
    ],
  },
  { url: "/outbound/delivery-note-view", name: "View Delivery Note" },
  {
    url: "/outbound/outbound-create-delivery-note",
    name: "Create Delivery Note",
  },

  {
    url: "/outbound/outbound-packingslip",
    name: "PackingSlip List",
    removeOn: [
      "/outbound/outbound-packingslip-view/",
      "/outbound/outbound-create-packingslip",
    ],
  },
  { url: "/outbound/outbound-packingslip-view/", name: "View PackingSlip" },
  { url: "/outbound/outbound-create-packingslip", name: "Create PackingSlip" },

  { url: "/outbound/shippinglist-edit/", name: "Shipment Edit" },
  { url: "/outbound/shippinglist-view/", name: "Shipment View" },
  { url: "/outbound/shippinglist", name: "Shipment List" },
  { url: "/outbound/shippinglist-create", name: "Shipment Create" },

  { url: "/outbound/outbound/sales-invoice", name: "Sales Invoice List" },
  { url: "/outbound/outbound/view-sales-invoice/", name: "Sales Invoice View" },
  { url: "/outbound/outbound/edit-sales-invoice/", name: "Sales Invoice Edit" },
  {
    url: "/outbound/outbound/create-sales-invoice/",
    name: "Create Sales Invoice",
  },

  // Master Routes
  { url: "/master/serialno/serialno-list", name: "Serial Number List" },
  { url: "/master/serialno/serialno-create", name: "Create Serial Number" },
  { url: "/master/serialno/serialno-view/", name: "View Serial Number" },
  { url: "/master/serialno/serialno-edit/", name: "Edit Serial Number" },
  { url: "/item/item-list", name: "Item List" },
  { url: "/item/create-item", name: "Create Item" },
  { url: "/item/edit-item", name: "Edit Item" },
  { url: "/item/view-item", name: "View Item" },
  { url: "/master/item/duplicate-item", name: "Duplicate Item" },
  { url: "/itemgroup/item-group-list", name: "Item Group List" },
  { url: "/itemgroup/create-item-group", name: "Create Item Group" },
  { url: "/itemgroup/edit-item-group", name: "Edit Item Group" },
  { url: "/itemgroup/view-item-group", name: "View Item Group" },
  {
    url: "/master/brand/brand-list",
    name: "Brand List",
    removeOn: [
      "/master/brand/create-brand",
      "/master/brand/edit-brand/",
      "/master/brand/view-brand/",
    ],
  },

  { url: "/master/brand/create-brand", name: "Create Brand" },
  { url: "/master/brand/edit-brand/", name: "Edit Brand" },
  { url: "/master/brand/view-brand/", name: "View Brand" },
  { url: "/tax/tax-list", name: "Tax List" },
  { url: "/tax/create-tax", name: "Create Tax" },

  {
    url: "/master/suppliergroup/supplier-list",
    name: "Supplier Group List",
    removeOn: [
      "/master/suppliergroup/create-supplier",
      "/master/suppliergroup/view-supplier",
      "/master/suppliergroup/edit-supplier",
    ],
  },
  {
    url: "/master/suppliergroup/create-supplier",
    name: "Create Group Supplier",
  },
  { url: "/master/suppliergroup/create-supplier", name: "Create Group Supplier" },
  { url: "/master/suppliergroup/view-supplier", name: "View Group Supplier" },
  { url: "/master/suppliergroup/edit-supplier", name: "Edit Group Supplier" },
  { url: "/assmbly/create-pick", name: "Create Pick" },
  { url: "/assmbly/draft/create-assembly", name: "Create Work Order" },
  { url: "/assmbly/pick-list", name: "Pick List" },

  { url: "/master/company/company-list", name: "Company List" },
  { url: "/master/company/create-Company", name: "Create Company" },

  {
    url: "/master/customer/customer-list",
    name: "Customer List",
    removeOn: [
      "/master/customer/create-customer",
      "/master/customer/view-customer",
      "/master/customer/edit-customer",
    ],
  },
  { url: "/master/customer/create-customer", name: "Create Customer" },
  { url: "/master/customer/view-customer/", name: "View Customer" },
  { url: "/master/customer/edit-customer/", name: "Edit Customer" },
  {
    url: "/master/address/address-list",
    name: "Address List",
    removeOn: [
      "/master/address/create-address",
      "/master/address/view-address",
      "/master/address/edit-address",
    ],
  },
  { url: "/master/address/create-address", name: "Create Address" },
  { url: "/master/address/view-address/", name: "View Address" },
  { url: "/master/address/edit-address/", name: "Edit Address" },

  {
    url: "/master/gsthsncode/gst-hsn-list",
    name: "GST HSN Code",
    removeOn: [
      "/master/gsthsncode/gst-hsn-create",
      "/master/itemtax/edit-item-tax",
      "/master/itemtax/view-item-tax",
    ],
  },
  { url: "/master/gsthsncode/gst-hsn-create", name: "Create GST HSN Code" },
  { url: "/master/gsthsncode/gst-hsn-edit/", name: "Edit GST HSN Code" },
  { url: "/master/gsthsncode/gst-hsn-view/", name: "View GST HSN Code" },

  {
    url: "/master/tax/tax-list",
    name: "Sales Taxes and Charges Template ",
    removeOn: [
      "/master/tax/create-tax",
      "/master/tax/edit-tax",
      "/master/tax/view-tax",
    ],
  },
  {
    url: "/master/tax/create-tax",
    name: "Create Sales Taxes and Charges Template",
  },
  {
    url: "/master/tax/edit-tax",
    name: "Edit Sales Taxes and Charges Template",
  },
  {
    url: "/master/tax/view-tax",
    name: "View Sales Taxes and Charges Template",
  },

  {
    url: "/master/tax/purchase-tax-list",
    name: "Purchase Taxes and Charges Template ",
    removeOn: [
      "/master/tax/purchase-create-tax",
      "/master/tax/purchase-edit-tax",
      "/master/tax/purchase-view-tax",
    ],
  },
  {
    url: "/master/tax/purchase-create-tax",
    name: "Create Purchase Taxes and Charges Template",
  },
  {
    url: "/master/tax/purchase-edit-tax",
    name: "Edit Purchase Taxes and Charges Template",
  },
  {
    url: "/master/tax/purchase-view-tax",
    name: "View Purchase Taxes and Charges Template",
  },

  {
    url: "/master/itemtax/item-tax-list",
    name: "Item Tax List",
    removeOn: [
      "/master/itemtax/create-item-tax",
      "/master/itemtax/edit-item-tax",
      "/master/itemtax/view-item-tax",
    ],
  },
  { url: "/master/itemtax/create-item-tax", name: "Create Item Tax" },

  { url: "/master/itemtax/edit-item-tax", name: "Edit Item Tax" },
  { url: "/master/itemtax/view-item-tax", name: "View Item Tax" },
  {
    url: "/master/warehouse-list",
    name: "Warehouse List",
    removeOn: [
      "/master/create-warehouse",
      "/master/warehouse-view",
      "/master/warehouse-edit",
    ],
  },
  { url: "/master/create-warehouse", name: "Create Warehouse" },
  { url: "/master/warehouse-view", name: "View Warehouse" },
  { url: "/master/warehouse-edit", name: "Edit Warehouse" },

  {
    url: "/master/bin-list",
    name: "Bin List",
    removeOn: ["/master/create-bin", "/master/bin-view", "/master/bin-edit"],
  },
  { url: "/master/create-bin", name: "Create Bin" },
  { url: "/master/bin-view", name: "View Bin" },
  { url: "/master/bin-edit", name: "Edit Bin" },
  {
    url: "/master/contact-list",
    name: "Contact List",
    removeOn: ["/master/create-contact", "/master/view-contact"],
  },
  { url: "/master/create-contact", name: "Create Contact" },
  { url: "/master/view-contact", name: "View Contact" },

  { url: "/create-contact", name: "Create Contact" },
  { url: "/master/company/company-list", name: "Company List" },
  { url: "/master/company/create-Company", name: "Create Company" },
  { url: "/master/company/edit-Company", name: "Edit Company" },
  { url: "/master/company/view-Company", name: "View Company" },

  { url: "/master/item/item-list", name: "Item List" },
  { url: "/master/item/create-item", name: "Create Item" },
  { url: "/master/item/edit-item/", name: "Edit Item" },
  { url: "/master/item/view-item/", name: "View Item" },
  { url: "/master/item/item-create", name: "Item-create" },

  { url: "/master/item/item-list-new", name: "Item List" },
  { url: "/master/item/item-create", name: "Create Item" },

  { url: "/master/itemgroup/item-group-list", name: "Item Group List" },
  { url: "/master/itemgroup/create-item-group", name: "Create Item Group" },
  { url: "/master/itemgroup/edit-item-group/", name: "Edit Item Group" },
  { url: "/master/itemgroup/view-item-group/", name: "View Item Group" },

  { url: "/master/uom/uom-list", name: "UOM List" },
  { url: "/master/uom/create-uom", name: "Create UOM" },
  { url: "/master/uom/edit-uom/", name: "Edit UOM" },
  { url: "/master/uom/view-uom/", name: "View UOM" },

  {
    url: "/master/item-attribute/item-attribute-list",
    name: "Item Attribute List",
  },
  {
    url: "/master/item-attribute/create-item-attribute",
    name: "Create Item Attribute",
  },
  {
    url: "/master/item-attribute/edit-item-attribute/",
    name: "Edit Item Attribute",
  },
  {
    url: "/master/item-attribute/view-item-attribute/",
    name: "View Item Attribute",
  },

  { url: "/master/item-price/item-price-list", name: "Item Price List" },
  { url: "/master/item-price/create-item-price", name: "Create Item Price" },
  { url: "/master/item-price/edit-item-price/", name: "Edit Item Price" },
  { url: "/master/item-price/view-item-price/", name: "View Item Price" },

  { url: "/master/supplier/supplier-list", name: "Supplier List" },
  { url: "/master/supplier/create-supplier", name: "Create Supplier" },
  { url: "/master/supplier/view-supplier/", name: "View Supplier" },
  { url: "/master/supplier/edit-supplier/", name: "Edit Supplier" },

  { url: "/master/payment-term/payment-term-list", name: "Payment Term List" },
  {
    url: "/master/payment-term/create-payment-term",
    name: "Create Payment Term",
  },
  { url: "/master/payment-term/view-payment-term/", name: "View Payment Term" },
  { url: "/master/payment-term/edit-payment-term/", name: "Edit Payment Term" },

  {
    url: "/master/payment-term-template/payment-term-template-list",
    name: "Payment Term Template List",
  },
  {
    url: "/master/payment-term-template/create-payment-term-template",
    name: "Create Payment Term Template",
  },
  {
    url: "/master/payment-term-template/view-payment-term-template/",
    name: "View Payment Term Template",
  },
  {
    url: "/master/payment-term-template/edit-payment-term-template/",
    name: "Edit Payment Term Template",
  },
  {
    url: "/master/quality-inspection/main-list",
    name: "Quality Inspection List",
  },
  {
    url: "/master/quality-inspection/create-quality-inspection",
    name: "Create Quality Inspection",
  },
  {
    url: "/master/Invoice-Creation/Create-opening-invoice-Creation-Tool/CreateInvoiceCreation",
    name: "Create Opening Invoice Creation Tool",
  },


  {
    url: "/master/bank-account/bank-account-list", name: "Bank Account List", removeOn: ["/master/bank-account/create-bank-account", "master/bank-account/view-bank-account", "master/bank-account/edit-bank-account"]
  },
  { url: "/master/bank-account/create-bank-account", name: "Create Bank Account" },
  { url: "/master/bank-account/edit-bank-account", name: "Edit Bank Account" },
  { url: "/master/bank-account/view-bank-account", name: "View Bank Account" },

  // New customer Routes
  { url: "/customer/create-customer", name: "Create Customer Entry" },

  // Assembly Routes
  { url: "/assmbly/assembly-list", name: "Work Order List" },
  { url: "/assmbly/create-assembly", name: "Create Work Order" },
  { url: "/assmbly/view-work-order", name: "View Work Order" },
  { url: "/draft/create-assembly", name: "Draft Assembly" },
  { url: "/assmbly/bom-list/", name: "BOM List" },
  { url: "/assmbly/create-bom", name: "Create BOM" },
  { url: "/assmbly/edit-bom", name: "Edit BOM" },
  { url: "/assmbly/create-pick", name: "Create Pick" },
  { url: "/assmbly/stock-entry", name: "Stock Entry" },

  // Dev Routes
  { url: "/dev/icons", name: "Icons" },
  { url: "/dev/button", name: "Button Showcase" },

  // Report Routes
  { url: "/Inventory/Inventory-Report", name: "Inventory Report" },
  { url: "/Inventory/Inventory-Bin-Wise", name: "Inventory Bin Wise" },
  { url: "/Inventory/Inventory-Item-Wise", name: "Inventory Item Wise" },
  { url: "/Inventory/Inventory-Client-Wise", name: "Inventory Client Wise" },
  { url: "/Inventory/Lot-Inventory-Bin-Wise", name: "Lot Inventory Bin Wise" },
  { url: "/Inventory/Blank-Bin-Report", name: "Blank Bin Report" },
  {
    url: "/Inventory/Lot-Inventory-Item-Wise",
    name: "Lot Inventory Item Wise",
  },
  {
    url: "/Inventory/Pivot-Inventory-Bin-Wise",
    name: "Pivot Inventory Bin Wise",
  },
  { url: "/Inventory/Item-Aging", name: "Item Aging" },
  { url: "/Inventory/Bin-Aging", name: "Bin Aging" },
  { url: "/Inventory/Item-Movement", name: "Item Movement" },
  { url: "/Inventory/Item-Qauntities", name: "Item Quantities" },
  { url: "/Inventory/UOM-Report", name: "UOM Report" },
  { url: "/Outbound/Posted-Shipment-Report", name: "Posted Shipment Report" },
  { url: "/Outbound/Posted-Pick-Report", name: "Posted Pick Report" },
  { url: "/Outbound/Posted-Box-Reports", name: "Posted Box Reports" },
  { url: "/Outbound/Sales-Order-Cycle", name: "Sales Order Cycle" },
  { url: "/Outbound/Pending-Pick", name: "Pending Pick" },
  { url: "/Outbound/Pending-Shipment", name: "Pending Shipment" },
  { url: "/Outbound/Delivery-Report", name: "Delivery Report" },
  { url: "/Outbound/Outbound-Cycle", name: "Outbound Cycle" },
  { url: "/Outbound/Back-Order-Report", name: "Back Order Report" },
  { url: "/Outbound/Sales-Return-Report", name: "Sales Return Report" },
  { url: "/Outbound/Posted-Manifest", name: "Posted Manifest" },
  { url: "/Outbound/Posted-Box", name: "Posted Box" },
  { url: "/Outbound/Outbound-Cycle-Details", name: "Outbound Cycle Details" },
  { url: "/Outbound/Pick-Reservation", name: "Pick Reservation" },
  {
    url: "/LedgerEntries/Ledger-Entries-Report",
    name: "Ledger Entries Report",
  },
  { url: "/LedgerEntries/Warehouse-Entry", name: "Warehouse Entry" },
  { url: "/LedgerEntries/Value-Entry-Report", name: "Value Entry Report" },
  { url: "/LedgerEntries/GST-Ledger-Report", name: "GST Ledger Report" },
  {
    url: "/LedgerEntries/Item-Forecast-Analysis",
    name: "Item Forecast Analysis",
  },
  { url: "/Auto-Email", name: "Auto Email" },
  { url: "/Billing-Reports", name: "Billing Reports" },
  { url: "/Final-Posting-Date", name: "Final Posting Date" },
  { url: "/Warehouse-Report/Adjustment-Report", name: "Warehouse Report" },
  { url: "/Warehouse-Report/BinMovement-Report", name: "Bin Movement Report" },
  {
    url: "/Warehouse-Report/Assembly-Consolidated",
    name: "Assembly Consolidated",
  },
  { url: "/Warehouse-Report/Assembly-Report", name: "Assembly Report" },
  { url: "/Warehouse-Report/TO-Report", name: "TO Report" },
  { url: "/stock-ledger", name: "Stock Ledger" },
  { url: "/warehouse-ledger", name: "Warehouse Ledger" },
  { url: "/purchase-analytics", name: "Purchase Analytics" },
  { url: "/purchase-order-analytics", name: "Purchase Order Analytics" },
  { url: "/report/warehouse-ledger", name: "Warehouse Ledger List" },
  { url: "/report/stock-ledger", name: "Stock Ledger List" },
  { url: "/report/purchase-analytics", name: "Purchase Analytics" },
  { url: "/report/purchase-order-analytics", name: "Purchase Order Analytics" },
  { url: "/report/purchase-order-trends", name: "Purchase Order Trends" },
  {
    url: "/report/item-wise-purchase-history",
    name: "Item Wise Purchase History",
  },
  {
    url: "/report/items-to-order-and-receive",
    name: "Items To Order And Receive",
  },
  {
    url: "/report/supplier-wise-sales-analytics",
    name: "Supplier Wise Sales Analytics",
  },
  { url: "/report/sales-analytics-report", name: "Sales Analytics Report" },
  { url: "/report/sales-order-analytics", name: "Sales Order Analytics" },
  { url: "/report/item-wise-sales-history", name: "Item Wise Sales History" },
  { url: "/report/stock-analytics", name: "Stock Analytics" },
  { url: "/report/delivery-note-trends", name: "Delivery Note Trends" },
  { url: "/report/purchase-receipt-trends", name: "Purchase Receipt Trends" },
  {
    url: "/report/batch-wise-balance-history",
    name: "Batch Wise Balance History",
  },
  { url: "/report/work-order-summary", name: "Work Order Summary" },
  { url: "/report/job-card-summary", name: "Job Card Summary" },
  { url: "/report/bom-stock-report", name: "Bom Stock Report" },
  {
    url: "/report/work-order-consumed-materials",
    name: "Work Order Consumed Materials",
  },

  { url: "/usermanage/login-track", name: "Login Logs" },
  { url: "/outbound/sales-return/", name: "Sales Return" },
  { url: "/outbound/view-sales-return/", name: "Sales Return View" },
  { url: "/outbound/edit-sales-return/", name: "Sales Return Edit" },

  { url: "/melting/create-melting-request", name: "Create Melting Request" },
  { url: "/melting/melting-request-list", name: "Melting Request List" },

  { url: "/oldgold/old-gold-entry-create", name: "Old Gold Entry Create" },
  { url: "/oldgold/old-gold-entry-list", name: "Old Gold Entry List" },

  // Quality Goal
  { url: "/master/quality-goal/quality-goal-list", name: "Quality Goal List" },
  {
    url: "/master/quality-goal/create-quality-goal",
    name: "Create Quality Goal",
  },
  { url: "/master/quality-goal/edit-quality-goal", name: "Edit Quality Goal" },
  { url: "/master/quality-goal/view-quality-goal", name: "View Quality Goal" },

  // Quality Procedure
  { url: "/master/quality-procedure/quality-procedure-list", name: "Quality Procedure List" },
  { url: "/master/quality-procedure/create-quality-procedure", name: "Create Quality Procedure" },
  { url: "/master/quality-procedure/edit-quality-procedure", name: "Edit Quality Procedure" },
  { url: "/master/quality-procedure/view-quality-procedure", name: "View Quality Procedure" },


  {
    url: "/master/quality-inspection/main-list",
    name: "Quality Inspection List",
  },
    // Quality Procedure
  { url: "/master/quality-procedure/quality-procedure-list", name: "Quality Procedure List" },
{ url: "/master/quality-inspection/main-list", name: "Quality Inspection List" },


//Quality Review
{ url: "/master/quality-review/quality-review-list", name: "Quality Review List" },
{ url: "/master/quality-review/create-quality-review", name: "Create Quality Review" },


// Budget
{ url: "/master/budget/budget-list", name: "Budget List" },
{ url: "/master/budget/create-budget", name: "Create Budget" },
{ url: "/master/budget/edit-budget", name: "Edit Budget" },
{ url: "/master/budget/view-budget", name: "View Budget" },

// Budget
{ url: "/master/add/add-list", name: "Accounting Dimension Details List" },

//Quality Review
{ url: "/master/currency-exchange-details/currency-exchange-details-list", name: "Currency Exchange Details List" },
{ url: "/master/currency-exchange-details/create-currency-exchange-details", name: "Create Currency Exchange Details" },
{ url: "/master/currency-exchange-details/edit-currency-exchange-details", name: "Edit Currency Exchange Details" },
{ url: "/master/currency-exchange-details/view-currency-exchange-details", name: "View Currency Exchange Details" },

//Quality Action List
{ url: "/master/quality-action-list", name: "Quality Action List" },
{ url: "/master/quality-action-list/new-quality-action", name: "New Quality Action" },
  // voucher 
   {
    url: "/Master/Voucher/PeriodClosingVoucher/Period-Closing-Voucher-List",
    name: "Period Closing Voucher List",
  },
  {
    url: "/Master/Voucher/PeriodClosingVoucher/NewPeriodClosingVoucher",
    name: "Create Period Closing Voucher",
  },
 {
    url: "/Master/Voucher/PeriodClosingVoucher/PeriodClosingVoucherDetails",
    name: "Period Closing Voucher Details",
  },
   // Exchange Rate Revaluation List 
    {
    url: "/Master/ExchangeRateRevaluation/mainList/ExchagereteRevalutionhead",
    name: "Exchange Rate Revaluation List",
  },
    {
    url: "/Master/ExchangeRateRevaluation/Create-ExchangeRateRevaluation/AddExchangeRateRevaluation",
    name: "Create Exchange Rate Revaluation",
  },
  {
    url: "/Master/CostCenterAllocation/CostCenterAllocationList/CostCenterAllocationList",
    name: "Cost Center Allocation List",
  },
    {
    url: "/Master/CostCenterAllocation/CreateCostCenterAllocation/NewCostCenterAllocation",
    name: "Create Cost Center Allocation",
  },
  {
    url: "/Master/CostCenterAllocation/View-CostCenterAllocationDetail/CostCenterAllocationDetail",
    name: "Cost Center Allocation Detail",
  },
    {
    url: "/Master/JournalEntry/main-list/JournalEntry",
    name: "Journal Entry List",
  },
    {
    url: "/Master/JournalEntry/Create-JournalEntry/AddJournalEntry",
    name: "Create Journal Entry",
  },
  {
    url: "/Master/JournalEntryTemplate/main-list/JournalEntryTemplateList",
    name: "Journal Entry Template List",
  },
    {
    url: "/Master/JournalEntryTemplate/Create-JournalEntryTemplate/CreateJournalEntryTemplate",
    name: "Create Journal Entry Template",
  },
     {
    url: "/Master/PaymentEntry/Main-List/PaymentEntryList",
    name: "Payment Entry List",
  },
   {
    url: "/Master/CustomerEntryForm/Main-List/CustomerEntryFormList",
    name: "Create Payment Entry",
  },
  {
    url: "/Master/CustomerEntryForm/Create-NewCustomerEntryForm/NewCustomerEntryForm",
    name: "Create Customer Entry Form",
  },
  {
    url: "/master/customer-repair/customer-repair-list",
    name: "Customer Repair List",
  },
  {
    url: "/master/customerdatafeedback/main-list/customerdataandfeedbackformlist",
    name: "Customer Data and Feedback Form List",
  },
      {
    url: "/master/customerdatafeedback/create-customerdatafeedbackform/customerdatafeedbackform",
    name: "Customer Data Feedback Form",
  },
        {
    url: "/master/customerdatafeedback/view-details/customerdataandfeedbackform",
    name: "Customer Data & Feedback Form",
  },
   {
    url: "/master/productview/main-list/productviewlist",
    name: "Product ViewList",
  },
     {
    url: "/master/productview/create-productview/createproductview",
    name: "Customer Product View",
  },

];

// You can also create a function to find a route by path
export const getRouteName = (path) => {
  const route = ROUTE_MAP.find((r) => path == r.url);
  return route ? route.name : "Unknown Page";
};
